import { UserDto } from '@dhl/mdp-api'
import type { User } from '~/modules/users/model'

export const convertToUser = (userDto: UserDto & { organisationName?: string; parcelShopName?: string }): User => ({
  ...userDto,
  email: userDto.email?.address ?? '',
})
